import { render, staticRenderFns } from "./veStuGraduationYxbysShow.vue?vue&type=template&id=19c54ec2&scoped=true"
import script from "./veStuGraduationYxbysShow.vue?vue&type=script&lang=js"
export * from "./veStuGraduationYxbysShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c54ec2",
  null
  
)

export default component.exports